/* MAMEIDO Zubehör-Slider (snippets/mameido-zubehoer.liquid)
   - Pro Karte ein Zubehör-Produkt; die Variante wählt man im Dropdown, das Bild wechselt mit
   - passt die Variante automatisch zur Größe (z. B. "passend für 1 l") und Farbe des Hauptprodukts
   - der Plus-Knopf legt genau die gewählte Variante in den Warenkorb, danach öffnet das Theme den Warenkorb-Schieber */
(function () {
  'use strict';

  function fmt(s) { return (s || '').replace(/\s*€/, ' €'); }
  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function words(s) { return String(s || '').split(/[^a-z0-9äöüß]+/).filter(Boolean); }
  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function init(root) {
    if (root.__mzb) return;
    root.__mzb = true;

    var main = { sizes: {}, colors: {} };
    try { main = JSON.parse(root.querySelector('[data-mzb-main]').textContent); } catch (e) { /* ohne Auto-Auswahl */ }
    var phrase = root.getAttribute('data-phrase') || 'passend für {size}';
    var matchSize = root.getAttribute('data-match-size') !== 'false';
    var matchColor = root.getAttribute('data-match-color') !== 'false';
    var colorMap = {};
    (root.getAttribute('data-color-map') || '').split('\n').forEach(function (line) {
      var i = line.indexOf('=');
      if (i > 0) colorMap[norm(line.slice(0, i))] = norm(line.slice(i + 1));
    });
    var wrap = root.querySelector('.mzb__wrap');
    var track = root.querySelector('[data-mzb-track]');
    var prev = root.querySelector('[data-mzb-prev]');
    var next = root.querySelector('[data-mzb-next]');
    var dots = [].slice.call(root.querySelectorAll('.mzb__dot'));
    var status = root.querySelector('[data-mzb-status]');
    var swipeTimer = null;
    var cards = [].slice.call(root.querySelectorAll('[data-mzb-card]'));

    function say(t) { if (status) status.textContent = t; }

    function mainId() {
      var field = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return field ? field.value : (window.mameido && window.mameido.variant ? window.mameido.variant.id : '');
    }

    /* ---------- Karten ---------- */
    function setupCard(card) {
      var data;
      try { data = JSON.parse(card.querySelector('[data-mzb-data]').textContent); } catch (e) { return; }
      var all = data.v || [];
      var img = card.querySelector('[data-mzb-img]');
      var select = card.querySelector('[data-mzb-select]');
      var label = card.querySelector('[data-mzb-var]');
      var price = card.querySelector('[data-mzb-price]');
      var colorIdx = -1;
      var sizeIdx = -1;
      (data.names || []).forEach(function (n, i) {
        var d = norm(n);
        if (d.indexOf('farbe') > -1 || d.indexOf('color') > -1 || d.indexOf('colour') > -1) colorIdx = i;
        if (d.indexOf('gr') === 0 || d.indexOf('size') > -1 || d.indexOf('ml') > -1 || d.indexOf('volum') > -1) sizeIdx = i;
      });
      // Name mit Größe: z. B. "Manschette 1 l" (aus "M - passend für 1 l" wird "1 l")
      var nameEl = card.querySelector('.mzb__name');
      var baseName = nameEl ? nameEl.textContent.trim() : '';
      function sizeOf(v) {
        if (sizeIdx < 0 || !v) return '';
        var val = String(v.o[sizeIdx] || '').replace(/\s+/g, ' ').trim();
        var m = val.match(/passend\s+f[üu]r\s+(.+)$/i);
        return m ? m[1].trim() : (val === 'Default Title' ? '' : val);
      }
      function setName(v) {
        if (!nameEl) return;
        var size = sizeOf(v);
        nameEl.textContent = baseName;
        if (size) {
          var sp = document.createElement('span');
          sp.className = 'mzb__size';
          sp.textContent = ' ' + size;
          nameEl.appendChild(sp);
        }
      }
      var current = null;
      var userPicked = false;

      function byId(id) {
        for (var i = 0; i < all.length; i++) if (String(all[i].id) === String(id)) return all[i];
        return null;
      }

      function pool() {
        var p = all;
        var size = main.sizes && main.sizes[String(mainId())];
        if (matchSize && size) {
          var needle = norm(phrase.replace('{size}', size));
          var f = all.filter(function (v) { return norm(v.o.join(' / ')).indexOf(needle) > -1; });
          if (f.length) p = f;
        }
        return p;
      }

      function show(v) {
        if (!v) return;
        current = v;
        setName(v);
        card.setAttribute('data-variant', v.id);
        if (price) {
          price.textContent = '';
          if (v.c) {
            var s = document.createElement('s');
            s.textContent = fmt(v.c);
            price.appendChild(s);
          }
          var sp = document.createElement('span');
          sp.textContent = fmt(v.p);
          price.appendChild(sp);
        }
        if (img && v.i && img.getAttribute('src') !== v.i) {
          img.classList.add('is-fading');
          window.setTimeout(function () {
            img.src = v.i;
            img.classList.remove('is-fading');
          }, 120);
        }
        if (select) select.value = String(v.id);
      }

      function update() {
        var p = pool();
        // Welche Optionen unterscheiden sich noch? Nur diese stehen im Dropdown.
        var varying = [];
        if (p.length) {
          for (var i = 0; i < p[0].o.length; i++) {
            var vals = {};
            p.forEach(function (v) { vals[v.o[i]] = true; });
            if (Object.keys(vals).length > 1) varying.push(i);
          }
        }
        function labelOf(v) { return varying.map(function (i) { return v.o[i]; }).join(' · '); }

        // Auswahl: bisherige Wahl behalten, sonst gleiche Farbe wie das Hauptprodukt, sonst die erste
        // Eine eigene Wahl bleibt bestehen, sonst wird bei jedem Wechsel des Hauptprodukts neu vorgewählt
        var pick = (userPicked && current && p.indexOf(current) > -1) ? current : null;
        if (!pick && matchColor && colorIdx > -1) {
          var mc = norm(main.colors && main.colors[String(mainId())]);
          if (mc) {
            // 1. Zuordnung aus dem Editor ("Smoke Black = Carbon"), 2. gleicher Name, 3. Zubehör-Farbe steckt im Namen ("Gold" in "Crystal Gold")
            var target = colorMap[mc];
            if (target) p.forEach(function (v) { if (!pick && norm(v.o[colorIdx]) === target) pick = v; });
            if (!pick) p.forEach(function (v) { if (!pick && norm(v.o[colorIdx]) === mc) pick = v; });
            if (!pick) {
              var mt = words(mc);
              p.forEach(function (v) {
                if (pick) return;
                var vt = words(norm(v.o[colorIdx]));
                if (vt.length && vt.every(function (w) { return mt.indexOf(w) > -1; })) pick = v;
              });
            }
          }
        }
        if (!pick) pick = p[0];

        if (select) {
          if (varying.length && p.length > 1) {
            select.textContent = '';
            p.forEach(function (v) {
              var o = document.createElement('option');
              o.value = String(v.id);
              o.textContent = labelOf(v);
              select.appendChild(o);
            });
            select.hidden = false;
            if (label) label.hidden = true;
          } else {
            select.hidden = true;
            if (label) {
              label.textContent = pick ? pick.o.join(' · ') : '';
              label.hidden = !label.textContent || label.textContent === 'Default Title';
            }
          }
        }
        show(pick);
      }

      if (select) {
        select.addEventListener('change', function () {
          userPicked = true;
          show(byId(select.value));
        });
      }

      card.__mzbSize = norm(sizeOf(all[0]));
      card.__mzbUpdate = update;
      update();

      var add = card.querySelector('[data-mzb-add]');
      if (add) {
        add.addEventListener('click', function () {
          var id = Number(card.getAttribute('data-variant'));
          if (!id || card.classList.contains('is-loading')) return;
          card.classList.add('is-loading');
          fetch(routeRoot() + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          })
            .then(function (response) {
              return response.json().then(function (d) { return { ok: response.ok, data: d }; });
            })
            .then(function (result) {
              card.classList.remove('is-loading');
              if (!result.ok) {
                say((result.data && result.data.description) || 'Das lässt sich gerade nicht in den Warenkorb legen.');
                return;
              }
              var item = (result.data && result.data.items && result.data.items[0]) || result.data;
              card.classList.add('is-added');
              window.setTimeout(function () { card.classList.remove('is-added'); }, 1800);
              say('In den Warenkorb gelegt.');
              card.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: { product: item, addToCartBtn: add },
                bubbles: true
              }));
            })
            .catch(function () {
              card.classList.remove('is-loading');
              say('Das lässt sich gerade nicht in den Warenkorb legen.');
            });
        });
      }
    }

    cards.forEach(setupCard);

    /* Karten zur gewählten Größe des Hauptprodukts stehen vorn, die übrigen Größen dahinter */
    var original = cards.slice();
    var lastOrder = '';
    function reorder() {
      var size = norm(main.sizes && main.sizes[String(mainId())]);
      var first = [];
      var rest = [];
      original.forEach(function (c) {
        if (size && c.__mzbSize && c.__mzbSize === size) first.push(c); else rest.push(c);
      });
      var ordered = first.concat(rest);
      var key = ordered.map(function (c) { return original.indexOf(c); }).join(',');
      if (key === lastOrder) return;
      lastOrder = key;
      ordered.forEach(function (c) { track.appendChild(c); });
      cards = ordered;
      track.scrollLeft = 0;
    }
    reorder();

    /* ---------- Hauptprodukt wechselt: Größe/Farbe neu abgleichen ---------- */
    function refresh() {
      cards.forEach(function (c) { if (c.__mzbUpdate) c.__mzbUpdate(); });
      reorder();
      updateNav();
    }
    document.addEventListener('variant:change', function () { window.setTimeout(refresh, 0); });
    var last = mainId();
    window.setInterval(function () {
      var now = mainId();
      if (now !== last) { last = now; refresh(); }
    }, 700);

    /* ---------- Slider: Pfeile und Punkte ---------- */
    function step() { return cards[0] ? cards[0].offsetWidth + 8 : 300; }

    function updateNav() {
      root.classList.toggle('mzb--scroll', track.scrollWidth > track.clientWidth + 4);
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (prev) { prev.classList.toggle('is-off', atStart); prev.disabled = atStart; }
      if (next) { next.classList.toggle('is-off', atEnd); next.disabled = atEnd; }
      if (dots.length) {
        var idx = 0;
        var x = track.scrollLeft + 8;
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].offsetLeft + cards[i].offsetWidth * 0.5 > x) { idx = i; break; }
          idx = i;
        }
        if (atEnd) idx = cards.length - 1;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () {
      updateNav();
      wrap.classList.add('is-swiping');
      window.clearTimeout(swipeTimer);
      swipeTimer = window.setTimeout(function () { wrap.classList.remove('is-swiping'); }, 1400);
    }, { passive: true });
    window.addEventListener('resize', updateNav, { passive: true });
    updateNav();
  }

  function boot(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-mzb]'), init);
  }

  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
